module.exports = __webpack_public_path__ + "img/banner.d5425afb.png";